var Platform={
OS:'web',
select:function select(obj){return'web'in obj?obj.web:obj.default;}};


module.exports=Platform;


//////////////////
// WEBPACK FOOTER
// ./~/react-native-web/dist/apis/Platform/index.js
// module id = 287
// module chunks = 0